import React from 'react';
import { Helmet } from 'react-helmet';
import GlobalNavigationMenu from '../../components/GlobalNavigationMenu';

const WA_URL = "https://wa.me/5562996336178?text=Ol%C3%A1%2C%20vim%20do%20AI7X7%20e%20preciso%20de%20ajuda%20com%20uma%20solucao.%20Pode%20me%20orientar%3F";

const handleWhatsApp = () => {
  window.open(WA_URL, "_blank");
};

const Section = ({ title, items }) => (
  <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
    <h2 className="text-xl font-bold text-gray-900 mb-6">{title}</h2>
    <ul className="space-y-3">
      {items?.map((item, i) => (
        <li key={i} className="flex items-start gap-3">
          <span
            className="mt-1 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
            style={{ backgroundColor: '#10a37f' }}
          >
            <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </span>
          <span className="text-base text-gray-700 leading-relaxed">{item}</span>
        </li>
      ))}
    </ul>
  </div>
);

const CTAButton = () => (
  <div className="flex justify-center">
    <button
      onClick={handleWhatsApp}
      className="inline-flex items-center gap-3 px-10 py-5 rounded-2xl text-white text-lg font-bold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-green-300"
      style={{ backgroundColor: '#10a37f' }}
    >
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
      Falar com Especialista
    </button>
  </div>
);

const AtendimentoPremium = () => {
  return (
    <>
      <Helmet>
        <title>Atendimento Premium - AI7X7</title>
        <meta name="description" content="Suporte humano real com orientação personalizada, acompanhamento contínuo e ajuda prática para evoluir em qualquer área." />
      </Helmet>
      <div className="min-h-screen" style={{ backgroundColor: '#f7f7f8', fontFamily: "'Inter', system-ui, sans-serif" }}>

        {/* Header */}
        <div className="bg-white border-b border-gray-100 px-4 sm:px-6 lg:px-8 py-4">
          <div className="max-w-4xl mx-auto flex items-center justify-between">
            <GlobalNavigationMenu />
            <span className="text-sm font-semibold" style={{ color: '#10a37f' }}>AI7X7</span>
          </div>
        </div>

        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 space-y-12">

          {/* Page Title */}
          <div className="text-center">
            <span
              className="inline-block text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5"
              style={{ backgroundColor: '#e6f7f3', color: '#10a37f' }}
            >
              Suporte Humano Real
            </span>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
              Atendimento Premium
            </h1>
          </div>

          {/* Intro Section */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">O que é o Atendimento Premium?</h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              O Atendimento Premium é um suporte humano real oferecido pelo AI7X7, onde você recebe orientação personalizada, acompanhamento contínuo e ajuda prática para evoluir em qualquer área ou desafio. Aqui, você pode tirar dúvidas, encontrar soluções, se desenvolver profissionalmente e até se tornar especialista em um tema específico, com apoio direto de um ser humano preparado para te guiar com clareza, estratégia e motivação.
            </p>
          </div>

          {/* Top CTA */}
          <CTAButton />

          {/* Sections Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Section
              title="O que você tem direito"
              items={[
                'Atendimento humano real',
                'Solução personalizada sobre qualquer assunto',
                'Escolha um tema para se tornar especialista com acompanhamento de 1 mês até 1 ano',
                'Motivação contínua e suporte emocional',
                'Respostas diretas e práticas',
                'Apoio para encontrar soluções',
              ]}
            />
            <Section
              title="Para quem é"
              items={[
                'Estudantes, professores e profissionais',
                'Quem quer resultados rápidos',
                'Quem quer algo além da IA',
                'Quem busca orientação personalizada',
              ]}
            />
            <Section
              title="Por que confiar"
              items={[
                'Atendimento direto',
                'Privacidade garantida',
                'Respostas reais',
              ]}
            />
            <Section
              title="Regras"
              items={[
                'Pode escolher qualquer tema dentro da sua área',
                'Não realizamos diagnósticos, tratamentos ou análises clínicas',
                'Atuamos dentro da lei',
                'Respeito total (sem preconceito)',
                'Foco em evolução profissional',
              ]}
            />
          </div>

          {/* Bottom CTA */}
          <div className="pt-4 pb-10">
            <p className="text-center text-gray-500 text-base mb-6">
              Pronto para dar o próximo passo? Fale agora com um especialista.
            </p>
            <CTAButton />
          </div>

        </main>
      </div>
    </>
  );
};

export default AtendimentoPremium;
